<template>
  <div>
    <div class="w-100">
      <div
        class="logo-brand"
        :style="
          formModal.logoImg.url
            ? `background-image : url(${formModal.logoImg.url})`
            : `background-image : url(${NoImageIcon})`
        "
        :class="
          `${formModal.logoImg.url ? 'preview-image bg-transparent' : null}`
        "
      />
    </div>
  </div>
</template>

<script>
import NoImageIcon from "@/assets/images/icons/nopicture.png";

export default {
  props: {
    formModal: { type: [String, Object, Array], default: "" },
  },

  setup() {
    return {
      NoImageIcon,
    };
  },
};
</script>

<style scoped>
.logo-brand {
  margin: auto;
  fill: #8da2bc;
  background-color: #e9edf2;
  border: 1.5px dashed #ccd3dd;
  height: 23px;
  background-repeat: no-repeat;
  background-size: 8%;
  background-position: center;
  cursor: default;
}

.preview-image {
  background-size: contain;
  border: none;
  border-radius: 20px 20px 0 0;
}
</style>
